import { Component } from '@angular/core';

@Component({
  selector: 'rr-card-footer',
  standalone: false,

  templateUrl: './card-footer.component.html',
  styleUrl: './card-footer.component.scss'
})
export class CardFooterComponent {

}
